import { getPages } from '@/api/pages';
import { PageState } from '@/types/page';
import { RootState } from '@/types/store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type PageGetter = GetterTree<PageState, RootState>;

const state: PageState = {
  data: [],
  current_page: 1,
  first_page_url: 'http://cms.test/api/pages?page=1',
  from: 1,
  last_page: 1,
  last_page_url: null,
  next_page_url: null,
  path: 'http://cms.test/api/pages',
  per_page: 50,
  prev_page_url: null,
  to: 50,
  total: 0,
};

const getters: PageGetter = {
  pages: state => state.data,
  currentPage: state => state.current_page,
};

const actions: ActionTree<PageState, RootState> = {
  async getPages({ commit }): Promise<void> {
    commit('setPages', await getPages());
  },
};

const mutations: MutationTree<PageState> = {
  setPages(state: PageState, pageData: PageState): void {
    Object.assign(state, pageData);
  },
};

const content: Module<PageState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default content;
